import './App.css';

import { Layout, Typography } from 'antd';
import React from 'react';

const { Header, Content, Footer } = Layout;
const { Title } = Typography;
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import { useAccount } from 'wagmi';

import MenuList from '@/component/MenuList';
import AddIssue from '@/pages/AddIssue';
import IssueDetail from '@/pages/IssueDetail';
import Issues from '@/pages/Issues';
import Login from '@/pages/Login';
import MyIssues from '@/pages/MyIssues';

function App() {
  const { isConnected } = useAccount();

  return (
    <BrowserRouter basename="/">
      <Layout style={{ minHeight: '100vh' }}>
        <Header style={{ display: 'flex', alignItems: 'center', background: 'white' }}>
          <Link to="/">
            <Title level={4} style={{ margin: '0', marginRight: '20px' }}>
              Dao 6551
            </Title>
          </Link>
          <MenuList style={{ flex: '1' }} />
          {isConnected && <ConnectButton />}
        </Header>
        <Content style={{ padding: '50px', background: '#f5f5f5' }}>
          <main style={{ maxWidth: '1000px', margin: 'auto' }}>
            <Routes>
              <Route path="/" element={<Issues />} />
              <Route path="/issue/*" element={<IssueDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/my-issues" element={<MyIssues />} />
              <Route path="/add-issue" element={<AddIssue />} />
            </Routes>
          </main>
        </Content>
        <Footer style={{ textAlign: 'center', borderTop: '1px solid #e2e2e2' }}>
          Dao 6551 © 2023 Copyright reserved
        </Footer>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
